import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import TicketCard from './TicketCard';

const API = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export default function EticketView() {
  const { qrToken } = useParams();
  const [ticket, setTicket] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/eticket/ticket/${qrToken}`)
      .then(r => setTicket(r.data))
      .catch(() => setNotFound(true));
  }, [qrToken]);

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4 flex items-center justify-center" data-testid="eticket-view-page">
      {notFound ? (
        <p className="text-slate-600" data-testid="ticket-not-found">Ticket not found.</p>
      ) : !ticket ? (
        <Loader2 className="w-8 h-8 animate-spin text-[#0C2159]" />
      ) : (
        <TicketCard ticket={ticket} />
      )}
    </div>
  );
}
